<template>
  <div class="question">
    <div class="tableWrap">
      <div class="table">
        <div v-for="(item, index) in formData" :key="index" class="row">
          <div class="data">
            <h3 class="heading">{{item.title}}</h3>
            <h3>{{item.response}}</h3>
          </div>
          <edit @click="edit(index)" />
        </div>
      </div>
    </div>
    <div style="padding: 1em" class="shaded">
      <h2>This information will be used to generate an initial offer.</h2>
      <h2>Please ensure the information provided is as accurate as possible and that you have permission to do this on behalf of {{$store.state.formData.businessName}}</h2>
    </div>
    <div v-if="$store.state.quotationOnly === true" class="button Enabled" @click="process">
      <h3>Process</h3>
    </div>
    <div v-else class="button Enabled" @click="confirm">
      <h3>Confirm</h3>
    </div>
  </div>
</template>

<script>
import edit from "@/components/editIcon";
export default {
  components: {
    edit
  },
  methods: {
    process: function() {
      this.$router.push("decide");
    },
    confirm: function() {
      this.$router.push("contact");
    },
    edit: function(d) {
      this.$router.push("edit/" + d);
    }
  },
  computed: {
    formData: function() {
      return [
        {
          title: "Company Name",
          response: this.$store.state.formData.businessName
        },
        {
          title: "Industry sector",
          response: this.$store.state.formData.sector
        },
        {
          title: "Predicted Turnover",
          response:
            "£" +
            parseInt(
              this.$store.state.formData.turnover
            ).toLocaleString(undefined, { maximumFractionDigits: 2 })
        },
        {
          title: "Years Trading",
          response: this.$store.state.formData.yearsTrading
        },
        {
          title: "Expected Customers",
          response: this.$store.state.formData.customers
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.heading {
  font-weight: bold;
}
.row {
  display: grid;
  grid-template-columns: 1fr auto;
  margin-bottom: 0.5em;
  padding: 0.5em;
  //outline: solid var(--base-colour, #535450) 1px;
  background-color: rgba(255, 255, 255, 0.75);
  text-align: left;
  padding-left: 3em;
  @media (min-width: 768px) {
    column-gap: 1em;
    grid-template-rows: 1fr;
    h3 {
      font-size: x-large;
    }
  }
}
.data {
  display: grid;
  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
}
.tableWrap {
  width: 100%;
  margin: 2em;
}
.table {
}

.question {
  display: flex;
  flex-grow: 2;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  padding-left: 0em;
  padding-right: 0em;
  padding-bottom: 3em;
}
</style>